import { createApp } from 'vue';
import OrfToJpgConverter from '../Components/OrfToJpgConverter.vue';

const root = document.getElementById('orf-to-jpg-converter');
if (root) {
  createApp(OrfToJpgConverter).mount('#orf-to-jpg-converter');
}
